module.exports = __webpack_public_path__ + "static/media/contact.b0662220.jpg";